module.exports = __webpack_public_path__ + "img/forbes-28072019.7b354419.png";